import ko from 'knockout'
import { RaceSubHeaderViewModel, type RaceSubHeaderViewModelParams } from './RaceSubHeaderViewModel'
import template from './race.sub.header.tpl.html'

if (!ko.components.isRegistered('race-sub-header')) {
  ko.components.register('race-sub-header', {
    viewModel: {
      createViewModel: (params: RaceSubHeaderViewModelParams) => {
        const viewModel = new RaceSubHeaderViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
